import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TextInput from "../../components/common/TextInput";
import Button from "../../components/common/Button";
import { registerUser, checkUsername } from "../../api/authApi";
import { useAuth } from "../../hooks/useAuth";
import { FiUser, FiMail, FiLock, FiEye, FiEyeOff, FiUserPlus, FiPhone, FiGlobe } from "react-icons/fi";


// const COUNTRIES = [
//   { code: "BD", name: "Bangladesh", dialCode: "+880" },
//   { code: "IN", name: "India", dialCode: "+91" },
//   { code: "US", name: "United States", dialCode: "+1" },
//   // TO-DO: add more as needed
// ];

const COUNTRIES = [
  { code: "AF", name: "Afghanistan", dialCode: "+93" },
  { code: "AL", name: "Albania", dialCode: "+355" },
  { code: "DZ", name: "Algeria", dialCode: "+213" },
  { code: "AS", name: "American Samoa", dialCode: "+1684" },
  { code: "AD", name: "Andorra", dialCode: "+376" },
  { code: "AO", name: "Angola", dialCode: "+244" },
  { code: "AI", name: "Anguilla", dialCode: "+1264" },
  { code: "AG", name: "Antigua and Barbuda", dialCode: "+1268" },
  { code: "AR", name: "Argentina", dialCode: "+54" },
  { code: "AM", name: "Armenia", dialCode: "+374" },
  { code: "AW", name: "Aruba", dialCode: "+297" },
  { code: "AU", name: "Australia", dialCode: "+61" },
  { code: "AT", name: "Austria", dialCode: "+43" },
  { code: "AZ", name: "Azerbaijan", dialCode: "+994" },
  { code: "BS", name: "Bahamas", dialCode: "+1242" },
  { code: "BH", name: "Bahrain", dialCode: "+973" },
  { code: "BD", name: "Bangladesh", dialCode: "+880" },
  { code: "BB", name: "Barbados", dialCode: "+1246" },
  { code: "BY", name: "Belarus", dialCode: "+375" },
  { code: "BE", name: "Belgium", dialCode: "+32" },
  { code: "BZ", name: "Belize", dialCode: "+501" },
  { code: "BJ", name: "Benin", dialCode: "+229" },
  { code: "BM", name: "Bermuda", dialCode: "+1441" },
  { code: "BT", name: "Bhutan", dialCode: "+975" },
  { code: "BO", name: "Bolivia", dialCode: "+591" },
  { code: "BA", name: "Bosnia and Herzegovina", dialCode: "+387" },
  { code: "BW", name: "Botswana", dialCode: "+267" },
  { code: "BR", name: "Brazil", dialCode: "+55" },
  { code: "IO", name: "British Indian Ocean Territory", dialCode: "+246" },
  { code: "BG", name: "Bulgaria", dialCode: "+359" },
  { code: "BF", name: "Burkina Faso", dialCode: "+226" },
  { code: "BI", name: "Burundi", dialCode: "+257" },
  { code: "KH", name: "Cambodia", dialCode: "+855" },
  { code: "CM", name: "Cameroon", dialCode: "+237" },
  { code: "CA", name: "Canada", dialCode: "+1" },
  { code: "CV", name: "Cape Verde", dialCode: "+238" },
  { code: "KY", name: "Cayman Islands", dialCode: "+1345" },
  { code: "CF", name: "Central African Republic", dialCode: "+236" },
  { code: "TD", name: "Chad", dialCode: "+235" },
  { code: "CL", name: "Chile", dialCode: "+56" },
  { code: "CN", name: "China", dialCode: "+86" },
  { code: "CX", name: "Christmas Island", dialCode: "+61" },
  { code: "CO", name: "Colombia", dialCode: "+57" },
  { code: "KM", name: "Comoros", dialCode: "+269" },
  { code: "CG", name: "Congo", dialCode: "+242" },
  { code: "CD", name: "Congo, Democratic Republic of the", dialCode: "+243" },
  { code: "CK", name: "Cook Islands", dialCode: "+682" },
  { code: "CR", name: "Costa Rica", dialCode: "+506" },
  { code: "CI", name: "Cote d'Ivoire", dialCode: "+225" },
  { code: "HR", name: "Croatia", dialCode: "+385" },
  { code: "CU", name: "Cuba", dialCode: "+53" },
  { code: "CY", name: "Cyprus", dialCode: "+357" },
  { code: "CZ", name: "Czech Republic", dialCode: "+420" },
  { code: "DK", name: "Denmark", dialCode: "+45" },
  { code: "DJ", name: "Djibouti", dialCode: "+253" },
  { code: "DM", name: "Dominica", dialCode: "+1767" },
  { code: "DO", name: "Dominican Republic", dialCode: "+1809" },
  { code: "EC", name: "Ecuador", dialCode: "+593" },
  { code: "EG", name: "Egypt", dialCode: "+20" },
  { code: "SV", name: "El Salvador", dialCode: "+503" },
  { code: "GQ", name: "Equatorial Guinea", dialCode: "+240" },
  { code: "ER", name: "Eritrea", dialCode: "+291" },
  { code: "EE", name: "Estonia", dialCode: "+372" },
  { code: "ET", name: "Ethiopia", dialCode: "+251" },
  { code: "FK", name: "Falkland Islands (Malvinas)", dialCode: "+500" },
  { code: "FO", name: "Faroe Islands", dialCode: "+298" },
  { code: "FJ", name: "Fiji", dialCode: "+679" },
  { code: "FI", name: "Finland", dialCode: "+358" },
  { code: "FR", name: "France", dialCode: "+33" },
  { code: "GF", name: "French Guiana", dialCode: "+594" },
  { code: "PF", name: "French Polynesia", dialCode: "+689" },
  { code: "GA", name: "Gabon", dialCode: "+241" },
  { code: "GM", name: "Gambia", dialCode: "+220" },
  { code: "GE", name: "Georgia", dialCode: "+995" },
  { code: "DE", name: "Germany", dialCode: "+49" },
  { code: "GH", name: "Ghana", dialCode: "+233" },
  { code: "GI", name: "Gibraltar", dialCode: "+350" },
  { code: "GR", name: "Greece", dialCode: "+30" },
  { code: "GL", name: "Greenland", dialCode: "+299" },
  { code: "GD", name: "Grenada", dialCode: "+1473" },
  { code: "GP", name: "Guadeloupe", dialCode: "+590" },
  { code: "GU", name: "Guam", dialCode: "+1671" },
  { code: "GT", name: "Guatemala", dialCode: "+502" },
  { code: "GG", name: "Guernsey", dialCode: "+44" },
  { code: "GN", name: "Guinea", dialCode: "+224" },
  { code: "GW", name: "Guinea-Bissau", dialCode: "+245" },
  { code: "GY", name: "Guyana", dialCode: "+592" },
  { code: "HT", name: "Haiti", dialCode: "+509" },
  { code: "HN", name: "Honduras", dialCode: "+504" },
  { code: "HK", name: "Hong Kong", dialCode: "+852" },
  { code: "HU", name: "Hungary", dialCode: "+36" },
  { code: "IS", name: "Iceland", dialCode: "+354" },
  { code: "IN", name: "India", dialCode: "+91" },
  { code: "ID", name: "Indonesia", dialCode: "+62" },
  { code: "IR", name: "Iran, Islamic Republic of", dialCode: "+98" },
  { code: "IQ", name: "Iraq", dialCode: "+964" },
  { code: "IE", name: "Ireland", dialCode: "+353" },
  { code: "IM", name: "Isle of Man", dialCode: "+44" },
  { code: "IL", name: "Israel", dialCode: "+972" },
  { code: "IT", name: "Italy", dialCode: "+39" },
  { code: "JM", name: "Jamaica", dialCode: "+1876" },
  { code: "JP", name: "Japan", dialCode: "+81" },
  { code: "JE", name: "Jersey", dialCode: "+44" },
  { code: "JO", name: "Jordan", dialCode: "+962" },
  { code: "KZ", name: "Kazakhstan", dialCode: "+7" },
  { code: "KE", name: "Kenya", dialCode: "+254" },
  { code: "KI", name: "Kiribati", dialCode: "+686" },
  { code: "KP", name: "Korea, Democratic People's Republic of", dialCode: "+850" },
  { code: "KR", name: "Korea, Republic of", dialCode: "+82" },
  { code: "KW", name: "Kuwait", dialCode: "+965" },
  { code: "KG", name: "Kyrgyzstan", dialCode: "+996" },
  { code: "LA", name: "Lao People's Democratic Republic", dialCode: "+856" }
];


function RegisterPage() {
  const [form, setForm] = useState({
    name: "",
    username: "",
    country: "",
    dialCode: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    refer_by: "",
  });

  const [error, setError] = useState("");
  const [userNameErrors, setUserNameErrors] = useState("");
  const [countryError, setCountryError] = useState("");
  const [phoneError, setPhoneError] = useState("")

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [usernameSuggestions, setUsernameSuggestions] = useState([]);

  const [usernameStatus, setUsernameStatus] = useState({
    available: null,    // null | true | false
    message: "",
  });

  const [usernameChecking, setUsernameChecking] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfermPassword, setShowConfermPassword] = useState(false);



  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      const selected = COUNTRIES.find((c) => c.code === value);

      // update dial code
      setForm((prev) => ({
        ...prev,
        country: value,
        dialCode: selected ? selected.dialCode : "",
      }));

      // show message ONLY if not Bangladesh
      if (value && value !== "BD") {
        setCountryError("Please select the correct location. Where you are now.");
      } else {
        setCountryError(""); // clear message for Bangladesh
      }
      

      return;
    }

    if (name === "phone") {
      // keep only digits in phone input (optional)
      const cleaned = value.replace(/[^\d]/g, "");
      if (value.length !== 10){
        setPhoneError("Pleace Insert correct phone Number.")
      }
      if(value.length === 10){
        setPhoneError("");
      }
      setForm(prev => ({
        ...prev,
        phone: cleaned,
      }));
      return;
    }

    if (name === "username") {
      setUsernameStatus({ available: null, message: "" });
      setUsernameSuggestions([]);
    }
    setUserNameErrors("");

    setForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUsernameBlur = async () => {
  if (!form.username || form.username.trim().length < 3) return;

  try {
    setUsernameChecking(true);
    setUsernameStatus({ available: null, message: "" });
    setUsernameSuggestions([]);

    const res = await checkUsername(form.username.trim(), form.name.trim());

    // Username is available
    setUsernameStatus({
      available: res.data.available,
      message: res.data.message || "Username is available",
    });
    setUsernameSuggestions(res.data.suggestions || []);
  } catch (err) {
    console.error("Username check error:", err);

    if (err.response && err.response.status === 409) {
      // Username already exists
      const data = err.response.data;
      setUsernameStatus({
        available: false,
        message: data.message || "This username already exists. Please try a different username.",
      });
      // Only show suggestions if they exist and are valid
      if (data.suggestions && Array.isArray(data.suggestions) && data.suggestions.length > 0) {
        setUsernameSuggestions(data.suggestions);
      }
    } else if (err.response && err.response.status === 500) {
      // Server error - don't block the user
      const data = err.response.data;
      setUsernameStatus({
        available: null,
        message: data.message || "Unable to verify username. Please try again.",
      });
      setUsernameSuggestions([]);
    } else {
      // Network error or other issues - don't block the user
      setUsernameStatus({
        available: null,
        message: "Unable to verify username. Please check your connection.",
      });
      setUsernameSuggestions([]);
    }
  } finally {
    setUsernameChecking(false);
  }
};


const handleSelectSuggestedUsername = async (u) => {
  setForm(prev => ({ ...prev, username: u }));
  setUsernameChecking(true);
  setUsernameSuggestions([]);

  try {
    const res = await checkUsername(u, form.name.trim());
    setUsernameStatus({
      available: res.data.available,
      message: res.data.message || "Username is available",
    });
  } catch (err) {
    console.error("Suggested username check error:", err);

    if (err.response && err.response.status === 409) {
      // Suggested username is also taken
      const data = err.response.data;
      setUsernameStatus({
        available: false,
        message: data.message || "This username already exists. Please try a different username.",
      });
      // Show new suggestions if available
      if (data.suggestions && Array.isArray(data.suggestions) && data.suggestions.length > 0) {
        setUsernameSuggestions(data.suggestions);
      }
    } else if (err.response && err.response.status === 500) {
      // Server error
      setUsernameStatus({
        available: null,
        message: "Unable to verify username. Please try again.",
      });
    } else {
      // Network error
      setUsernameStatus({
        available: null,
        message: "Unable to verify username. Please check your connection.",
      });
    }
  } finally {
    setUsernameChecking(false);
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage(null);

    if (!form.name ||
        !form.username ||
        !form.country ||
        !form.email ||
        !form.phone ||
        !form.password ||
        !form.refer_by) {
      setError("All fields are required.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    if (form.country !== "BD") {
      setError("Select your current location.");
      return;
    }


    try {
      setLoading(true);

      // You must decide in backend how you detect email vs phone.
      const payload = {
        name: form.name,
        username: form.username,
        country: form.country,
        email: form.email,
        phone: `${form.dialCode}${form.phone}`, // e.g. +8801812345678
        password: form.password,
        refer_by: form.refer_by,
      };

      //const data = await registerUser(payload);
      const data = await registerUser(payload);
      setSuccessMessage(data.message || 'Registration successful!');

      // setTimeout(() => {
      //   navigate('/login'); 
      // }, 1000);
      
      //optional: auto login after register if backend returns token

      setTimeout(() => {
        if (data.auth_token && data.user) {
        login(data.auth_token, data.user);
        navigate("/", { replace: true });
      } else {
        navigate("/login");
      }
      }, 1000);
      
      
    } catch (err) {
      if (err.response && err.response.status === 409) {
      setError(err.response.data.message || "A conflict occurred.");
    } else {
      setError("An unexpected error occurred.");
    }
      //setError("Registration failed. Please check your info and refer ID.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50 px-4 py-8">
      <div className="w-full max-w-2xl animate-slideUp">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-full opacity-20 blur-lg"></div>
              <img
                src="/logo.png"
                alt="Review Market EU"
                className="relative h-16 w-16 object-contain"
              />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gradient mb-2">
            Join Review Market EU
          </h1>
          <p className="text-gray-600">Create your account and start earning</p>
        </div>

        {/* Registration Card */}
        <div className="card-gradient">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Create Account</h2>

        <form className="space-y-5" onSubmit={handleSubmit}>
          <div className="grid md:grid-cols-2 gap-5">
            <TextInput
              label="Full Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              icon={<FiUser className="h-5 w-5" />}
              required
            />

            <div>
              <TextInput
                label="User Name"
                name="username"
                value={form.username}
                onChange={handleChange}
                onBlur={handleUsernameBlur}
                placeholder="Choose a unique username"
                icon={<FiUserPlus className="h-5 w-5" />}
                required
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace", "Delete", "ArrowLeft", "ArrowRight",
                    "ArrowUp", "ArrowDown", "Tab", "Escape", "Enter"
                  ];
                  if (allowedKeys.includes(e.key)) return;
                  if (e.key === " ") {
                    e.preventDefault();
                    setUserNameErrors("Spaces are not allowed in username");
                  }
                  if (/[A-Z]/.test(e.key)) {
                    e.preventDefault();
                    setUserNameErrors("Uppercase letters are not allowed");
                  }
                }}
              />

              {userNameErrors && (
                <p className="mt-2 flex items-center gap-1 text-sm text-error animate-fadeIn">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {userNameErrors}
                </p>
              )}

              {usernameChecking && (
                <p className="mt-2 text-sm text-primary-600 flex items-center gap-2">
                  <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Checking username...
                </p>
              )}

              {usernameStatus.available === true && (
                <p className="mt-2 text-sm text-success flex items-center gap-1 animate-fadeIn">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  {usernameStatus.message || "Username is available"}
                </p>
              )}

              {usernameStatus.available === false && (
                <p className="mt-2 text-sm text-error flex items-center gap-1 animate-fadeIn">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                  {usernameStatus.message || "This username already exists. Please try a different username."}
                </p>
              )}

              {usernameStatus.available === null && usernameStatus.message && (
                <p className="mt-2 text-sm text-amber-600 flex items-center gap-1 animate-fadeIn">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {usernameStatus.message}
                </p>
              )}

              {usernameSuggestions.length > 0 && (
                <div className="mt-3 p-3 bg-primary-50 rounded-lg border border-primary-200 animate-fadeIn">
                  <p className="text-sm font-medium text-gray-700 mb-2">Suggested usernames:</p>
                  <div className="flex flex-wrap gap-2">
                    {usernameSuggestions.map((u) => (
                      <button
                        key={u}
                        type="button"
                        onClick={() => handleSelectSuggestedUsername(u)}
                        className="px-3 py-1.5 rounded-full bg-white border-2 border-primary-300 text-sm font-medium text-primary-700 hover:bg-primary-100 hover:border-primary-400 transition-all"
                      >
                        {u}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>



          <div className="grid md:grid-cols-2 gap-5">
            <div>
              <label className="mb-2 block font-medium text-gray-700">
                Country <span className="ml-1 text-error">*</span>
              </label>
              <div className="relative">
                <FiGlobe className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <select
                  name="country"
                  value={form.country}
                  onChange={handleChange}
                  required
                  className="input pl-10 appearance-none bg-white"
                >
                  <option value="">Select your country</option>
                  {COUNTRIES.map((c) => (
                    <option key={c.code} value={c.code}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </div>
              {countryError && (
                <p className="mt-2 flex items-center gap-1 text-sm text-error animate-fadeIn">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {countryError}
                </p>
              )}
            </div>

            <div>
              <label className="mb-2 block font-medium text-gray-700">
                Phone <span className="ml-1 text-error">*</span>
              </label>
              <div className="flex gap-2">
                <div className="relative w-24">
                  <FiPhone className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    value={form.dialCode || "+Code"}
                    disabled
                    className="input pl-10 bg-gray-50 text-gray-600 cursor-not-allowed"
                  />
                </div>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  min="10"
                  max="10"
                  required
                  className="input flex-1"
                  placeholder="Enter phone number"
                />
              </div>
              {phoneError && (
                <p className="mt-2 flex items-center gap-1 text-sm text-error animate-fadeIn">
                  <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                  {phoneError}
                </p>
              )}
            </div>
          </div>

          <TextInput
            label="Email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="your.email@example.com"
            icon={<FiMail className="h-5 w-5" />}
            required
          />

          <div className="grid md:grid-cols-2 gap-5">
            <div className="relative">
              <TextInput
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={form.password}
                onChange={handleChange}
                placeholder="Create a strong password"
                icon={<FiLock className="h-5 w-5" />}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-[42px] text-gray-400 hover:text-gray-600 transition-colors"
              >
                {showPassword ? (
                  <FiEyeOff className="h-5 w-5" />
                ) : (
                  <FiEye className="h-5 w-5" />
                )}
              </button>
            </div>

            <div className="relative">
              <TextInput
                label="Confirm Password"
                name="confirmPassword"
                type={showConfermPassword ? "text" : "password"}
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Re-enter your password"
                icon={<FiLock className="h-5 w-5" />}
                required
              />
              <button
                type="button"
                onClick={() => setShowConfermPassword(!showConfermPassword)}
                className="absolute right-3 top-[42px] text-gray-400 hover:text-gray-600 transition-colors"
              >
                {showConfermPassword ? (
                  <FiEyeOff className="h-5 w-5" />
                ) : (
                  <FiEye className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>

          <TextInput
            label="Refer By (Optional)"
            name="refer_by"
            value={form.refer_by}
            onChange={handleChange}
            placeholder="Enter referral code"
            icon={<FiUserPlus className="h-5 w-5" />}
          />

          {successMessage && (
            <div className="rounded-lg bg-green-50 px-4 py-3 text-sm text-green-700 border border-green-200 flex items-start gap-2 animate-fadeIn">
              <svg className="h-5 w-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>{successMessage}</span>
            </div>
          )}

          {error && (
            <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700 border border-red-200 flex items-start gap-2 animate-fadeIn">
              <svg className="h-5 w-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <Button
            type="submit"
            className="w-full"
            loading={loading}
            disabled={
              loading ||
              !form.username ||
              usernameStatus.available === false ||
              usernameChecking
            }
          >
            {loading ? "Creating your account..." : "Create Account"}
          </Button>
          {usernameStatus.available === null && usernameStatus.message && (
            <p className="mt-2 text-xs text-amber-600 text-center">
              Username verification failed, but you can still proceed. The server will validate during registration.
            </p>
          )}
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{" "}
            <Link
              to="/login"
              className="font-semibold text-primary-600 hover:text-primary-700 transition-colors"
            >
              Login
            </Link>
          </p>
        </div>
      </div>

      {/* Footer Text */}
      <p className="mt-6 text-center text-xs text-gray-500">
        By creating an account, you agree to our Terms of Service and Privacy Policy
      </p>
      </div>
    </div>
  );
}

export default RegisterPage;
